<template>
  <div>
    <common-dialog
      ref="dialog"
      width="850px"
      unit="多计量单位组"
      edit-title
      id-key="UnitGroupId"
      form-label-width="120px"
      :data="data"
      :line-form="true"
      :form-rules="rules"
      :before-save="onBeforeSave"
      :save-func="() => {}"
      @create-opened="onCreateOpened"
      @edit-opened="onEditOpened"
      close-on-saved
      @close-saved="onOver"
    >
      <template slot="form">
        <el-row>
          <el-col :span="12">
            <el-form-item label="计量单位组名称" prop="Name">
              <el-input v-model="data.Name" placeholder="请输入计量单位组名称" clearable=""></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="24">
            <el-form-item label="序号" prop="Sn" class="notBottom">
              <el-input type="number" v-int v-model="data.Sn" style="width: 100px; border-bottom: 1px solid #dcdfe6"></el-input>
              <!-- <el-input-number v-model.number="data.Sn" :min="0" step-strictly style="width: 100px"></el-input-number> -->
              <span class="t-tips">*值越小排得越前</span>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="24">
            <el-form-item label="状态" prop="Status">
              <el-radio-group v-model="data.Status">
                <el-radio :label="1">启用</el-radio>
                <el-radio :label="0">停用</el-radio>
              </el-radio-group>
            </el-form-item>
          </el-col>
        </el-row>

        <div class="row-tb-head">
          <span>单位列表</span>
          <div style="float: right">
            <el-button type="primary" @click="add">添加</el-button>
          </div>
        </div>
        <el-table ref="table" class="table-line tb-c-head" :rules="unitRules" :data="unitList" border>
          <el-table-column prop="UnitNo" label="计量单位编码" min-width="80" align="center">
            <template slot-scope="{ row, $index }">
              <el-input type="text" v-model="row.UnitNo" @input="changeT($event, $index)"></el-input>
            </template>
          </el-table-column>
          <el-table-column prop="UnitName" label="计量单位" min-width="80" align="center">
            <template slot-scope="{ row, $index }">
              <el-input type="text" v-model="row.UnitName" @input="changeT($event, $index)"></el-input>
            </template>
          </el-table-column>
          <el-table-column prop="IsMainUnit" label="主计量" min-width="80" align="center">
            <template slot-scope="{ row, $index }">
              <el-checkbox v-model="row.IsMainUnit" @change="changeT($event, $index)"></el-checkbox>
            </template>
          </el-table-column>
          <el-table-column prop="ChangeType" label="换算类型" min-width="80" align="center">
            <template slot-scope="{ row, $index }">
              <span v-if="row.IsMainUnit"></span>
              <el-select v-else v-model="row.ChangeType" @change="changeT($event, $index)">
                <el-option label="固定" :value="0"></el-option>
                <el-option label="浮动" :value="1"></el-option>
              </el-select>
            </template>
          </el-table-column>
          <el-table-column prop="ChangeRate" label="换算率" min-width="80" align="center">
            <template slot-scope="{ row, $index }">
              <el-input v-if="row.ChangeType === 0" type="number" :disabled="row.IsMainUnit" v-model="row.ChangeRate" @input="changeRate($event, $index)"></el-input>
              <span v-else>{{ row.ChangeRate }}</span>
            </template>
          </el-table-column>
          <el-table-column prop="RateDescription" label="换算说明" min-width="180" align="center">
            <template slot-scope="{ row, $index }">
              <el-input type="textarea" v-model="row.RateDescription" @input="changeT($event, $index)" placeholder="请输入结算说说明"></el-input>
            </template>
          </el-table-column>
          <el-table-column label="操作" min-width="55" align="center">
            <template slot-scope="{ row, $index }">
              <el-button type="text" class="del" @click="del(row, $index)">删除</el-button>
            </template>
          </el-table-column>
        </el-table>
      </template>
      <template slot="footer">
        <el-button type="primary" @click="toSave()">保 存</el-button>
        <el-button @click="close">关 闭</el-button>
      </template>
    </common-dialog>
  </div>
</template>
<script>
import editDialogMixin from '@/mixins/editDialog'
import commonDialog from '@/components/common/dialog'

export default {
  mixins: [editDialogMixin],
  components: {
    commonDialog
  },
  data() {
    return {
      api: require('@/api/ba/unitGroup').default,
      data: {
        UnitGroupId: 0,
        Name: '',
        Sn: null,
        BaUnits: []
      },
      unitList: [],
      Mode: 1,
      rules: {
        Name: [{ required: true, message: '计量单位组名称不能为空' }]
      },
      unitRules: {
        UnitName: [{ required: true, message: '计量单位不能为空' }],
        ChangeRate: [{ required: true, message: '换算率不能为空' }]
      },
      editType: 0
    }
  },
  computed: {},
  methods: {
    onCreateOpened(data) {
      this.editType = 0
      // console.log("onCreateOpened", data);
      this.unitList = []
      this.data.BaUnits = []
      this.api.getMaxSn().then(res => {
        this.data.Sn = res
      })
      // this.code_api.previewNo("颜色类别").then((res) => {
      //   console.log("serialType", res);
      //   if (res.Code == 0) {
      //     this.Mode = res.Data.Mode;
      //     this.data.UnitNo = res.Data.PreviewNo;
      //   } else {
      //     this.$message.warning("获取颜色类别编号失败");
      //   }
      // });
    },
    onEditOpened(data) {
      this.editType = 1
      this.api.info(data.UnitGroupId).then(res => {
        this.data = res.Data
        this.unitList = JSON.parse(JSON.stringify(res.Data.BaUnits)).map(i => ((i.T = 3), i))
      })
    },
    changeRate($event, $index) {
      if (this.unitList[$index].T === 3) this.unitList[$index].T = 1
    },
    changeT($event, $index) {
      if (this.unitList[$index].T === 3) this.unitList[$index].T = 1
      this.unitList[$index].ChangeRate = 1
    },
    onBeforeSave() {
      let unitUpdateList = this.unitList.filter(i => i.T === 1)
      let unitDelIds = this.unitList.map(item => item.UnitId)
      let unitDelList = this.data.BaUnits.reduce((arr, item) => {
        if (item.UnitId && !unitDelIds.includes(item.UnitId)) arr.push({ ...item, T: 2 })
        return arr
      }, [])
      let unitAddIds = this.data.BaUnits.map(item => item.UnitId)
      unitAddIds = unitAddIds.filter(item => {
        return item != null
      })
      let unitAddList = []
      unitAddList = this.unitList.reduce((arr, item) => {
        if (!item.UnitId && !unitAddIds.includes(item.UnitId)) arr.push({ ...item, T: 0 })
        return arr
      }, [])

      this.data.BaUnits = [...unitAddList, ...unitDelList, ...unitUpdateList]

      if (this.data.BaUnits.length === 0 && this.editType === 0) return this.$message.warning('单位列表不能为空')
    },
    toSave() {
      this.$refs.dialog.formValidate().then(valid => {
        if (!valid) return
        this.onBeforeSave()
        var data = this.$commonJs.obj.removeNullKey(this.data)
        //在这里修改同名问题
        console.log(this.data, '$$$$')
        this.api.save(data).then(res => {
          if (res.Code == 0) {
            this.$message.success(res.Msg)
            this.data = {}
            this.data.BaUnits = []
            this.close(1)
            this.onOver()
          } else {
            this.$message.error(res.Msg)
          }
        })
      })
    },
    add() {
      var len = this.unitList.length
      this.unitList.push({
        // 名称
        UnitName: '',
        // 换算说明
        RateDescription: '',
        // 换算率
        ChangeRate: '',
        // 是否主计量
        IsMainUnit: false,
        // 变动类型
        ChangeType: null,
        Sn: len + 1
      })
    },
    del(row, index) {
      console.log('===row===', row)
      console.log(index)
      this.$confirm('确认删除所选的数据吗？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      })
        .then(() => {
          this.unitList.splice(index, 1)
        })
        .catch(() => {})
    },
    onOver() {
      this.unitList = []
      this.data.BaUnits = []
      console.log('触发关闭')
      this.$emit('close-saved')
    }
    // closed(){
    //   this.unitList = []
    //   this.data.BaUnits =[]
    // }
  }
}
</script>

<style lang="scss" scoped>
.del {
  color: red;
}

/deep/ .notBottom .el-form-item__content {
  border-bottom: none;
}
</style>